// extracted by mini-css-extract-plugin
module.exports = {"NewAppeal":"new-appeal_NewAppeal__wnkV1","NewAppeal__title":"new-appeal_NewAppeal__title__QKLJB","NewAppeal__select":"new-appeal_NewAppeal__select__pPfRz"};